const galleryId = 89;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_1555107788.jpg","sh_1691417839.jpg","sh_1740610157.jpg","sh_1751363960.jpg","sh_1751363963.jpg","sh_1751363969.jpg","sh_1810254652.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Braces'));

group = ["sh_1627811614.jpg","sh_1627811617.jpg","sh_1426462499.jpg"];
group.forEach((i) => addItemToGroup(i, '2. Braces - procedure'));

group = ["sh_1505970371.jpg","sh_1582204045.jpg","sh_1829640869.jpg","sh_718198264.jpg","sh_1505970383.jpg","sh_100322954.jpg","sh_351429728.jpg","sh_1016998420.jpg","sh_1260768442.jpg","sh_1829640872.jpg"];
group.forEach((i) => addItemToGroup(i, '4. Invisible braces'));

group = ["sh_1309934584.jpg","sh_256705441.jpg","sh_544569958.jpg","sh_1408415669.jpg","sh_1486975643.jpg","sh_1555107689.jpg","sh_1578877885.jpg","sh_404596582.jpg","sh_556726783.jpg","sh_1751364059.jpg"];
group.forEach((i) => addItemToGroup(i, '5. Plastic braces'));

group = ["sh_1450336322.jpg","sh_1537207163.jpg","sh_1646434036.jpg","sh_155143142.jpg","sh_155143157.jpg"];
group.forEach((i) => addItemToGroup(i, '6. Lingual braces'));

group = ["sh_1555107794.jpg","sh_1486975727.jpg","sh_1713449407.jpg","sh_98426222.jpg","sh_394631302.jpg","sh_626628683.jpg","sh_1468855250.jpg","sh_1706939725.jpg"];
group.forEach((i) => addItemToGroup(i, '7. Retainer'));

group = ["sh_1444882430.jpg","sh_1710200212.jpg","sh_1741122356.jpg","sh_1741122362.jpg","sh_1741122368.jpg","sh_1741122452.jpg","sh_1810254682.jpg","sh_1829640764.jpg"];
group.forEach((i) => addItemToGroup(i, '8. Cleaning braces'));

group = ["sh_1713449461.jpg","sh_1254136210.jpg","sh_1309934572.jpg","sh_1191439462.jpg"];
group.forEach((i) => addItemToGroup(i, '9. Diasthema correction'));

group = ["sh_589167344.jpg","sh_1706390137.jpg","sh_1736737193.jpg","sh_1742967977.jpg","sh_1799915665.jpg","sh_1474623371.jpg","sh_1847059678.jpg","sh_1547164166.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

export default items;
